<template>
  <v-container :loading="loading">
    <v-row>
      <DetailOverview :contract="contract" :questionnaire="questionnaire" :user-vb="userVb" />

      <PositionOverview :positions="positions" :contract="contract.id" :invoiced-positions="invoicedPositions" />
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import DetailOverview from '@/Components/Contract/DetailOverview'
import PositionOverview from '@/Components/Contract/PositionOverview'

export default {
   components: {
      DetailOverview,
      PositionOverview,
   },
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : `Vertrag ${this.contract.number}`,
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      contract: {
         type: Object,
         required: true,
      },
      positions: {
         type: Array,
         required: true,
      },
      questionnaire: {
         type: Object,
         required: false,
         default () {
            return {}
         },
      },
      invoicedPositions: {
         type: Array,
         required: true,
      },
      userVb: {
         type: Object,
         required: false,
         default () {
            return {}
         },
      },
   },
   data () {
      return {
         loading: false,
         tab: 0,
      }
   },
   computed: {
      wholePrices () {
         const price = {
            mon: 0.0,
            k: 0.0,
         }
         this.positions
            .filter((pos) => pos.amount !== null)
            .forEach((pos) => {
               if (pos.billing_type === '1m') {
                  price.mon += parseFloat(pos.price)
               } else {
                  price.k += parseFloat(pos.price)
               }
            })
         return price
      },
   },
   methods: {
      openEnlargements () {
         this.$inertia.visit(
            this.route('contracts.enlargements.index', this.contract)
         )
      },
   },
}
</script>
